// extracted by mini-css-extract-plugin
module.exports = {"label":"questions-control-component_label__2aBsv","secondaryLabel":"questions-control-component_secondaryLabel__2PAWP"};